import React, { FunctionComponent, useEffect, useState } from "react";

import EmojiSelector from "./EmojiSelector";
import options, { Option } from "./options";

type EmojiStepProps = {
  setDescriptionText: React.Dispatch<React.SetStateAction<string | null>>;
  onOptionSelected: (option: Option) => void;
};

const EmojiStep: FunctionComponent<EmojiStepProps> = ({
  setDescriptionText,
  onOptionSelected,
}) => {
  const [optionHovered, setOptionHovered] = useState<Option | null>(null);
  useEffect(() => {
    setDescriptionText(optionHovered?.description || null);
  }, [optionHovered, setDescriptionText]);
  return (
    <div className="space-y-3">
      <h3 className="text-h3">How was your interview?</h3>
      <EmojiSelector
        options={options}
        onHoverOption={(option: Option | null): void => {
          setOptionHovered(option);
        }}
        onSelectOption={(option: Option): void => {
          onOptionSelected(option);
        }}
      />
    </div>
  );
};

export default EmojiStep;
